import { IssueCard } from './IssueCard';
import type { Issue } from '@/types/reportApp';

interface IssueListViewProps {
  issues: Issue[];
  editingIssue: string | null;
  readOnly?: boolean;
  onEdit: (id: string) => void;
  onCancelEdit: () => void;
  onUpdate: (issueId: string, updates: Partial<Issue>) => void;
  onApprove: (issueId: string) => void;
  onMoveToPending: (issueId: string) => void;
  onDismiss: (issueId: string) => void;
}

export function IssueListView({
  issues,
  editingIssue,
  readOnly = false,
  onEdit,
  onCancelEdit,
  onUpdate,
  onApprove,
  onMoveToPending,
  onDismiss,
}: IssueListViewProps) {
  return (
    <div className="space-y-2">
      {issues.map(issue => (
        <IssueCard
          key={issue.id}
          issue={issue}
          isEditing={editingIssue === issue.id}
          readOnly={readOnly}
          onEdit={() => onEdit(issue.id)}
          onCancelEdit={onCancelEdit}
          onUpdate={onUpdate}
          onApprove={() => onApprove(issue.id)}
          onMoveToPending={() => onMoveToPending(issue.id)}
          onDismiss={() => onDismiss(issue.id)}
        />
      ))}
    </div>
  );
}
